import { useState } from 'react';
import { submitChannels, submitSteps } from '@/mocks/stats';
import SectionHeading from './SectionHeading';

const accentCycle = [
  'bg-primary-100 text-primary-600',
  'bg-accent-100 text-accent-700',
  'bg-secondary-100 text-secondary-700',
  'bg-primary-100 text-primary-600',
];

export default function SubmitSection() {
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <section id="tougao" className="bg-background-50 border-b border-background-200">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-10 md:py-14">
        <SectionHeading
          index="05"
          title="投稿通道 · 让线索有机会曝光"
          subtitle="支持文字、聊天记录、视频素材与现场图片，分类整理，快速筛选"
          accent="primary"
        />

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {submitChannels.map((channel, index) => (
            <article
              key={channel.id}
              className="rounded-lg border border-background-200 bg-background-50 p-5 hover:border-primary-300 transition-colors"
            >
              <span className={`w-11 h-11 rounded-md flex items-center justify-center text-xl ${accentCycle[index % accentCycle.length]}`}>
                <i className={channel.icon}></i>
              </span>
              <h3 className="mt-3 font-heading font-bold text-base text-foreground-950">{channel.name}</h3>
              <p className="mt-1.5 text-sm text-foreground-600 leading-relaxed">{channel.desc}</p>
              <p className="mt-3 text-xs text-accent-700 bg-accent-50 px-2 py-1 rounded inline-block">{channel.tips}</p>
            </article>
          ))}
        </div>

        <div className="mt-8 rounded-lg border border-background-200 bg-background-100 p-5 md:p-6">
          <div className="flex flex-wrap items-center justify-between gap-4">
            <div>
              <h3 className="font-heading font-bold text-base md:text-lg text-foreground-950">一条线索是怎么被处理的</h3>
              <p className="mt-1 text-sm text-foreground-600">从收到投稿到整理曝光，共四个步骤，全程保持来源可追溯。</p>
            </div>
            <button
              type="button"
              onClick={() => setModalOpen(true)}
              className="inline-flex items-center gap-2 h-11 px-5 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-send-plane-fill"></i>
              我要投稿
            </button>
          </div>

          <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
            {submitSteps.map((step) => (
              <div key={step.step} className="relative rounded-md border border-background-200 bg-background-50 p-4">
                <span className="font-heading font-bold text-2xl text-background-300 leading-none">{step.step}</span>
                <h4 className="mt-2 text-sm font-bold text-foreground-900">{step.title}</h4>
                <p className="mt-1 text-xs text-foreground-600 leading-relaxed">{step.text}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {modalOpen ? (
        <div className="fixed inset-0 z-50 flex items-center justify-center px-4">
          <div
            className="absolute inset-0 bg-foreground-950/60"
            onClick={() => setModalOpen(false)}
            aria-hidden="true"
          ></div>
          <div className="relative w-full max-w-lg rounded-lg border border-background-200 bg-background-50 p-6">
            <div className="flex items-start justify-between gap-4">
              <div>
                <h3 className="font-heading font-bold text-lg text-foreground-950">投稿前请确认</h3>
                <p className="mt-1 text-sm text-foreground-600">为了保护当事人隐私，也为了线索更容易被采纳：</p>
              </div>
              <button
                type="button"
                onClick={() => setModalOpen(false)}
                className="w-8 h-8 rounded-md border border-background-200 text-foreground-600 hover:text-primary-600 hover:border-primary-300 flex items-center justify-center transition-colors cursor-pointer shrink-0"
                aria-label="关闭"
              >
                <i className="ri-close-line"></i>
              </button>
            </div>

            <ul className="mt-4 space-y-2.5">
              <li className="flex items-start gap-2.5 text-sm text-foreground-700">
                <i className="ri-checkbox-circle-line text-accent-600 mt-0.5"></i>
                写清时间、地点与事件经过，越具体越容易被整理。
              </li>
              <li className="flex items-start gap-2.5 text-sm text-foreground-700">
                <i className="ri-checkbox-circle-line text-accent-600 mt-0.5"></i>
                聊天记录请保留完整上下文，并对无关隐私信息打码。
              </li>
              <li className="flex items-start gap-2.5 text-sm text-foreground-700">
                <i className="ri-checkbox-circle-line text-accent-600 mt-0.5"></i>
                视频素材请注明拍摄时间与来源，原始文件更可靠。
              </li>
              <li className="flex items-start gap-2.5 text-sm text-foreground-700">
                <i className="ri-error-warning-line text-primary-600 mt-0.5"></i>
                请勿提交侵犯他人隐私或未经核实的内容。
              </li>
            </ul>

            <div className="mt-5 rounded-md border border-primary-200 bg-primary-50 px-4 py-3 text-xs text-foreground-700 leading-relaxed">
              当前为演示环境，投稿接口尚未接入。正式开放后，你可以通过文字、聊天记录、视频素材等任意渠道提交线索。
            </div>

            <div className="mt-5 flex justify-end">
              <button
                type="button"
                onClick={() => setModalOpen(false)}
                className="h-10 px-5 rounded-md bg-primary-500 text-background-50 text-sm hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                我知道了
              </button>
            </div>
          </div>
        </div>
      ) : null}
    </section>
  );
}